import { cn } from '~/lib/utils';
import { PlateElement, type PlateElementProps } from 'platejs/react';

export const TableElement = (props: PlateElementProps) => {
    return (
        <PlateElement
            as="table"
            className={cn(
                'my-4 w-full border-collapse',
                'table-fixed'
            )}
            {...props}
        />
    );
};

export const TableRowElement = (props: PlateElementProps) => {
    return <PlateElement as="tr" {...props} />;
};

export const TableCellElement = (props: PlateElementProps) => {
    return (
        <PlateElement
            as="td"
            className={cn(
                'border border-border p-2',
                'min-w-[48px] align-top',
                'bg-background'
            )}
            {...props}
        />
    );
};

export const TableCellHeaderElement = (props: PlateElementProps) => {
    return (
        <PlateElement
            as="th"
            className={cn(
                'border border-border p-2',
                'min-w-[48px] align-top',
                'bg-muted font-semibold text-left'
            )}
            {...props}
        />
    );
};
